<template>
  <div v-if="!isPooqzone" @click.prevent="toggle()" class="check-style02">
    <input :id="'check-alarm' + index" v-model="value" type="checkbox" class="check-time" alt="시청예약">
    <span v-if="value"><ScheduleIconOn /></span>
    <span v-else><ScheduleIconOff /></span>
    <label :for="'check-alarm' + index" class="blind">방송알림</label>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import ScheduleIconOff from '@/assets/svg/common/ic-detail-alart-off.svg'
import ScheduleIconOn from '@/assets/svg/common/ic-detail-alart-on.svg'
import { MyPooqService } from '@/common/api/api.service'
import {
  MSG_ASK_DELETE_ALARM_LIVE,
  MSG_COMPLETE_ADD_LIVE_ALARM,
  MSG_COMPLETE_DELETE_LIVE_ALARM
} from '@/common/constant'
export default {
  components: {
    ScheduleIconOff,
    ScheduleIconOn
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    isOn: {
      type: String,
      required: true
    },
    contentsId: {
      type: String,
      required: true
    },
    targetDate: {
      type: String,
      required: true
    },
    programId: {
      type: String
    },
    dataIndex: {
      type: Number
    },
    changeAlarmState: {
      type: Function
    }
  },
  data () {
    return {
      isPooqzone: utils.cookies.isPooqZone(),
      value: this.isOn === 'y'
    }
  },
  methods: {
    async toggle () {
      if (utils.cookies.getCredential() === 'none' && utils.cookies.getDevice() === 'mobile') {
        this.$router.push(window.location.href = '/login?referer=' + encodeURIComponent(location.href))
      } else {
        if (this.value) {
          // 알람 delete
          const res = await utils.asyncConfirm(MSG_ASK_DELETE_ALARM_LIVE)
          if (res) {
            MyPooqService.deleteAlarm({
              alarmtype: 'live',
              contentid: this.contentsId,
              releasedatetime: this.targetDate
            }).then(({ data }) => {
              if (data.resultcode === '200') {
                this.value = false
                this.changeAlarmState(this.dataIndex, this.value)
                this.$toast({ message: MSG_COMPLETE_DELETE_LIVE_ALARM })
              }
            })
          }
        } else {
          // 알람 insert
          MyPooqService.registAlarm({
            alarmtype: 'live',
            contentid: this.contentsId,
            releasedatetime: this.targetDate,
            programid: this.programId
          }).then(({ data }) => {
            if (data.resultcode === '200') {
              this.value = true
              this.changeAlarmState(this.dataIndex, this.value)
              this.$toast({ message: MSG_COMPLETE_ADD_LIVE_ALARM })
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="css">
.check-time {
  visibility: hidden;
}
.blind{
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  font-size: 0;
  line-height: 0;
}
</style>
